import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import SaleInvoice from '../../entities/sales/saleinvoice'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'
import appconst from '../../../lib/appconst'
import PageResult from '@/store/entities/page-result';
import Sale from '@/store/entities/sales/sale';

interface SaleInvoiceState extends ListState<SaleInvoice>{
    editModel:SaleInvoice;
}
class SaleInvoiceModule extends ListModule<SaleInvoiceState,any,SaleInvoice>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<SaleInvoice>(),
        loading:false,
        editModel: new SaleInvoice(),
        activeList: new Array<SaleInvoice>(),
        path: 'sale-invoices'         
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
        async getPendingInvoices(context: ActionContext<SaleInvoiceState, any>, payload: any) {
            context.state.totalCount = 0;
            context.state.list = [];
            context.state.loading = true;
            let reponse = await Ajax.get('/api/sale-invoices/pending', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.list = reponse.data.result;
            context.state.totalCount = context.state.list.length;
        },
        async getProcessedInvoices(context: ActionContext<SaleInvoiceState, any>, payload: any) {
            context.state.totalCount = 0;
            context.state.list = [];
            context.state.loading = true;
            let reponse = await Ajax.get('/api/sale-invoices/processed', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.list = reponse.data.result;
            context.state.totalCount = context.state.list.length;
        },
        async invoice(context: ActionContext<SaleInvoiceState, any>, payload: any) {
            context.state.loading = true; 
            let response = await Ajax.post('/api/sale-invoices', payload.data).catch(e => {
                context.state.loading = false;
                return false;
            });
            context.state.loading = false;
            if (!response)
                return response;
            else if ((response as any).data != undefined) 
                return (response as any).data.result;
            return false;
        },
        async downloadInvoiceFile(context: ActionContext<SaleInvoiceState, any>, payload: any) {
            context.state.loading = true;
            payload.data.saleinvoice = payload.data.id;
            let reponse = await Ajax.get('/api/sale-invoices-download', { params: payload.data }).then(response => {
                const url = response.data.result;
                const link = document.createElement('a');
                link.href = url;
                if (payload.data.type == 'pdf')
                    link.target = '_blank';
                link.setAttribute('download', payload.data.filename); //or any other extension
                document.body.appendChild(link);
                link.click();
            }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
        },
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
    });
}
const saleinvoiceModule=new SaleInvoiceModule();
export default saleinvoiceModule;